export default __webpack_public_path__ + "static/media/reports-option.5046c16b.png";